import { Controller } from "@hotwired/stimulus";

// Restores the "Välj sittplatser" flow that used to live in
// LoadActionsStep2.load_button_actions() (load_actions_step2.ts) --
// packs/desktop/step2.js never calls that (or any other LoadActionsStep2
// loader) for a #step_2_form.tw-page, so on this rebuilt page the seat
// availability check never ran and the button never got a click handler.
// Doesn't touch seat *rendering* at all -- step2/partials/_seating.html.erb
// and the asset-pipeline step2_seating.js (loaded by list_seating.js.erb's
// own response) are unchanged legacy pieces this just reconnects to.
//
// Desktop / flygcity-mobile-cutover renders a modalTarget (a hand-authored
// Tailwind dialog, same fixed-inset-0-backdrop pattern as
// booking_support_modal_controller.js's own support modal -- the actual
// proven convention for a modal in this app, not fancybox and not the
// never-used Ui::ModalComponent/generic `modal` controller). aob/flysmarter
// mobile (not yet cut over) has no modalTarget at all and keeps the exact
// previous fancybox-based open/close wiring untouched.
export default class extends Controller {
  static targets = ["modal"];
  static values = { url: String };

  connect() {
    // list_seating.js.erb responds as a plain .js template (Rails
    // format.js) -- $.get() is what makes jQuery auto-evaluate that
    // response as script, exactly like the original rails-ujs-era call
    // did. That response itself calls $("#toggle_seating_link").toggle()
    // once seats actually exist, revealing the button, and replaces
    // #seating's content with the real seat map.
    $.get(this.urlValue);
  }

  // Old design's exact two-part contract (load_actions_step2.ts, recovered
  // from git history): opening the seatmap -- from this link OR from
  // step2-submit's own gate below -- always marks #seating_viewed checked
  // first (viewing it is what's required, not actually picking a seat),
  // and closing it (picked a seat or not) re-clicks the real submit button
  // to continue the flow automatically, exactly like the old fancybox
  // afterClose callback did.
  open(event) {
    if (event) event.preventDefault();
    $("#seating_viewed").prop("checked", true);

    if (this.hasModalTarget) {
      if (!this.modalTarget.classList.contains("hidden")) return;
      this.modalTarget.classList.remove("hidden");
      return;
    }

    const seating = $("#seating");
    if (seating.is(":visible")) return;

    $.fancybox.open({
      src: "#seating",
      opts: {
        afterClose: () => {
          document.getElementById("step_2_submit_btn")?.click();
        },
      },
    });
  }

  close() {
    this.modalTarget.classList.add("hidden");
    document.getElementById("step_2_submit_btn")?.click();
  }

  // Wired on the modal backdrop itself -- event.currentTarget is always
  // that backdrop element; event.target is whatever was actually clicked,
  // equal only when the click landed on the backdrop, not a bubbled click
  // from the card/content inside it.
  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close();
  }
}
